import { gsap } from 'gsap';
import 'slick-carousel';
import 'bootstrap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import 'jquery.cookie';




var markers = false;

var is_mobile = false;


var windowWidth = window.innerWidth;
var windowHeight = window.innerHeight;
window.addEventListener('resize', function() {
 windowWidth = window.innerWidth;
 windowHeight = window.innerHeight; 

 checkIsMobile();
});



var literka_przes = 0.15*windowWidth;
var literka_tlo_przes = 0.1*windowWidth;
var text_przes = 0.15*windowWidth;

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

function checkIsMobile(){
  if (isMobileDevice() && $('#is_mobile').css('display') === 'block') {
    is_mobile = true;
  }else{
    is_mobile = false;
  }

}

function scrollTo(hash){
  $('html, body').animate({
    scrollTop: $(hash).offset().top - 95
  }, 500);
}
gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.querySelector('.menu-toggle');
  const menuContainer = document.querySelector('.menu-menu-container');
  const menuContainer2 = document.querySelector('.menu-menu-english-container');
  const menuContainer3 = document.querySelector('.menu-menu-es-container');

  // Funkcja zmieniająca stan aktywny przycisku i menu
  menuToggle.addEventListener('click', function() {
    menuToggle.classList.toggle('is-active'); // Zmiana wyglądu przycisku (krzyżyk)
    if(menuContainer)
    menuContainer.classList.toggle('is-open'); // Ukrywanie/wyświetlanie menu
    if(menuContainer2)
    menuContainer2.classList.toggle('is-open'); // Ukrywanie/wyświetlanie menu
    if(menuContainer3)
    menuContainer3.classList.toggle('is-open'); // Ukrywanie/wyświetlanie menu
  });
});

function animation() {
          
}
function animationBack() {  

}

document.addEventListener('DOMContentLoaded', function() {
  
  checkIsMobile();

  if(is_mobile){
    $('#video').remove();
  }else{
    $('#video_mobile').remove();
  }
 


  window.addEventListener('scroll', () => {
    if (window.scrollY > 150) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }
  });

  if (window.location.hash) {
    // Pobiera hash z URL
    const hash = window.location.hash.substring(1); // Usuwa # z początku
      
      // Przewija stronę do elementu o ID odpowiadającym hashowi
      const element = document.getElementById(hash);
      if (element) {
        scrollTo('#'+hash);
          
      }
  }
  
if(is_mobile === false){

// Wybierz wszystkie elementy .image i .opis wewnątrz .locations
const images = document.querySelectorAll('.locations .image');



// gsap.from('.dane_firmy', {
//   scrollTrigger: {
//     trigger: "#kontakt",      // Ustaw trigger na element #kontakt
//     start: "top 80%",         // Początek animacji, gdy #kontakt dotrze do 80% widoku
//     end: "bottom 20%",        // Koniec animacji, gdy #kontakt jest 20% widoku od dołu
//     scrub: 1,                 // Prędkość animacji zależy od przewijania
//   },
//   y: 300,                    // Przesunięcie z lewej (poza ekranem)
//   opacity: 0,                 // Startowa przezroczystość
//   ease: "power2.out"          // Płynne wjeżdżanie
// });

const opisy = document.querySelectorAll('.locations .opis');

// Animacja dla elementów .image (wjeżdżają z lewej)
// images.forEach((image) => {
//   gsap.from(image, {
//     scrollTrigger: {
//       trigger: "#kontakt",      // Ustaw trigger na element #kontakt
//       start: "top 80%",         // Początek animacji, gdy #kontakt dotrze do 80% widoku
//       end: "bottom 20%",        // Koniec animacji, gdy #kontakt jest 20% widoku od dołu
//       scrub: 1,                 // Prędkość animacji zależy od przewijania
//     },
//     x: -100,                    // Przesunięcie z lewej (poza ekranem)
//     opacity: 0,                 // Startowa przezroczystość
//     ease: "power2.out"          // Płynne wjeżdżanie
//   });
// });

// Animacja dla elementów .opis (wjeżdżają z prawej)
// opisy.forEach((opis) => {
//   gsap.from(opis, {
//     scrollTrigger: {
//       trigger: "#kontakt",      // Ustaw trigger na element #kontakt
//       start: "top 50%",         // Początek animacji, gdy #kontakt dotrze do 80% widoku
//       end: "bottom 50%",        // Koniec animacji, gdy #kontakt jest 20% widoku od dołu
//       scrub: 0.5,                 // Prędkość animacji zależy od przewijania
//     },
//     x: 100,                     // Przesunięcie z prawej (poza ekranem)
//     opacity: 0,                 // Startowa przezroczystość
//     ease: "power2.out",          // Płynne wjeżdżanie

//   });
// });

// Wybieramy wszystkie elementy client-item
const clientsHolder = document.querySelector("#clients_holder_2");
const clientsElements = document.querySelector("#clients_holder_2 .clientsElements");
const clientItems = gsap.utils.toArray(".client-item");

// gsap.from(clientItems, {
//   scrollTrigger: {
//     trigger: '#clients_holder_2',      // Ustaw trigger na całą sekcję #projekty
//     start: "top 80%",          // Animacja zaczyna się, gdy górna część #projekty dotrze do 80% widoku
//     end: "bottom 20%",         // Koniec animacji po dotarciu do dolnej części #projekty
//     toggleActions: "play none play reverse", // Animacja odtwarzana w dół i w górę
//   },
//   opacity: 0,                  // Początkowa przezroczystość
//   x: 100,                      // Startowe przesunięcie w osi X (poza ekranem po prawej)
//   duration: 0.6,               // Szybsza animacja (0.6 sekundy)
//   stagger: 0.1,                // Opóźnienie między animacjami elementów (każdy kolejny z opóźnieniem 0.1s)
//   ease: "power2.out"           // Wygładzenie animacji
// });
  // Zmienna do przechowywania obecnej animacji GSAP
  let currentAnimation;
  let currentDirection;
  

  // Funkcja do obliczania szerokości wszystkich elementów i szerokości ekranu
  function calculateWidths() {
    // Obliczamy łączną szerokość wszystkich elementów
    let totalWidth = 0;
    if(clientsHolder){
    clientItems.forEach(item => {
      totalWidth += item.offsetWidth;
    });

    // Pobieramy szerokość widocznej części kontenera (szerokość ekranu)
    const containerWidth = clientsHolder.offsetWidth;

    // Dodajemy szerokość ostatniego elementu, żeby nie był ucięty
    const lastItemWidth = clientItems[clientItems.length - 1].offsetWidth;

    $(clientsElements).css({'width': totalWidth+'px'});

    return { totalWidth, containerWidth, lastItemWidth };
  }
  return false;
    // Zwracamy szerokości i szerokość ostatniego elementu
  }

  // Funkcja animacji w lewo
  function animateLeft(speed = 12) {
    currentDirection = 'left';
    const { totalWidth, containerWidth, lastItemWidth } = calculateWidths();

    currentAnimation = gsap.to(clientsElements, {
      x: -(totalWidth - containerWidth + lastItemWidth),  // Przesunięcie o łączną szerokość minus widoczna część plus szerokość ostatniego elementu
      duration: speed,    // Dynamicznie dostosowana prędkość
      ease: "linear",  // Używamy liniowej animacji (stała prędkość)
      onComplete: animateRight  // Po zakończeniu przejścia w lewo, uruchom przesuwanie w prawo
    });
  }

  // Funkcja animacji w prawo
  function animateRight(speed = 12) {
    currentDirection = 'right';
    currentAnimation = gsap.to(clientsElements, {
      x: 0,           // Przesunięcie z powrotem do pozycji początkowej (prawo)
      duration: speed,   // Dynamicznie dostosowana prędkość
      ease: "linear", // Płynna animacja
      onComplete: animateLeft  // Po zakończeniu przesunięcia w prawo, uruchom przesuwanie w lewo
    });
  }

  // Uruchamiamy animację

  setTimeout(function(){
    animateLeft();
  }, 1500);
  






  // const items = document.querySelectorAll('.project-item');
  
  // gsap.from(items, {
  //   scrollTrigger: {
  //     trigger: '#projekty',      // Ustaw trigger na całą sekcję #projekty
  //     start: "top 80%",          // Animacja zaczyna się, gdy górna część #projekty dotrze do 80% widoku
  //     end: "bottom 20%",         // Koniec animacji po dotarciu do dolnej części #projekty
  //     toggleActions: "play none play reverse", // Animacja odtwarzana w dół i w górę
  //   },
  //   opacity: 0,                  // Początkowa przezroczystość
  //   x: 100,                      // Startowe przesunięcie w osi X (poza ekranem po prawej)
  //   duration: 0.6,               // Szybsza animacja (0.6 sekundy)
  //   stagger: 0.1,                // Opóźnienie między animacjami elementów (każdy kolejny z opóźnieniem 0.1s)
  //   ease: "power2.out"           // Wygładzenie animacji
  // });

  const projectLists = document.querySelectorAll('.projects-list');

  // Funkcja do obliczenia przesunięcia na podstawie pozycji myszy
  function handleMouseMove(event, currentRow) {
    const mouseX = event.clientX; // Pozycja myszy na osi X
    const windowWidth = window.innerWidth;
  
    // Prędkość dla rzędu pod kursorem
    const translateXFocused = ((mouseX / windowWidth) * 100 - 50) * -0.6; // Prędkość X
    // Prędkość dla pozostałych rzędów
    const translateXOther = ((mouseX / windowWidth) * 100 - 50) * -0.2; // Prędkość Y
  
    projectLists.forEach((list, index) => {
      if (list === currentRow) {
        // Jeśli kursor jest nad tym rzędem, przesuwa się z prędkością X
        gsap.to(list, {
          x: translateXFocused + '%',
          duration: 0.3,
          ease: "power2.out"
        });
      } else {
        // Pozostałe rzędy przesuwają się z prędkością Y
        gsap.to(list, {
          x: translateXOther + '%',
          duration: 0.3,
          ease: "power2.out"
        });
      }
    });
  }
  
  // Dodaj nasłuchy dla każdego rzędu
  // projectLists.forEach((list) => {
  //   list.addEventListener('mousemove', (event) => handleMouseMove(event, list));
  // });



  // Znajdź element p w kontenerze #animation_text_opacity
const paragraph = document.querySelector("#animation_text_opacity p");

if(paragraph){

// Pobierz tekst paragrafu z pominięciem elementów em i strong
let words = Array.from(paragraph.childNodes).map(node => {
    if (node.nodeType === Node.TEXT_NODE) {
        // Podziel tekst na słowa i owiniemy każde słowo w <span>
        return node.textContent.split(" ").map(word => {
            if (word.trim() !== "") {
                return `<span>${word}</span>`;
            } else {
                return word; // Zachowaj spacje
            }
        }).join(" ");
    } else if (node.nodeName !== 'EM' && node.nodeName !== 'STRONG') {
        // Jeśli to nie <em> i <strong>, zachowaj oryginalny element
        return node.outerHTML;
    }
    return node.outerHTML; // Zachowaj <em> i <strong> bez zmian
}).join(" ");

// Zastąp zawartość paragrafu nowym HTML-em
paragraph.innerHTML = words;

// Znajdź wszystkie span-y wewnątrz #animation_text_opacity, w tym <strong> i <em>
let spans = document.querySelectorAll("#animation_text_opacity span, #animation_text_opacity strong, #animation_text_opacity em");

// Użyj GSAP do animacji każdego słowa (span) na scroll
gsap.from(spans, {
  opacity: 0, // Cel to pełna widoczność (alpha 100)
  stagger: 0.1, // Opóźnienie pomiędzy animacjami dla kolejnych słów
  duration: 0.5, // Czas trwania animacji dla każdego słowa
  ease: "power2.out", // Płynna animacja
  scrollTrigger: {
    trigger: "#animation_text_opacity", // Element wyzwalający animację
    start: "top 95%",  // Animacja startuje, gdy element dotknie 80% wysokości okna
    end: "top 50%", // Kończy się, gdy element prawie opuszcza ekran
    scrub: true, // Płynne zsynchronizowanie animacji z przewijaniem
    markers: false // Możesz ustawić na true, aby debugować pozycje startu i końca
  }
});
}
$(".im_text").each(function(){
  var id = $(this).attr('id');
  gsap.from("#"+id+" .left .image", {
    x:  -literka_przes, // Przesunięcie o 10% w prawo
    alpha: 0,
    scrollTrigger: {
      trigger: "#"+id,  // Ustawiamy kontener jako punkt wyzwalania
      start: "top center",  // Animacja startuje, gdy górna część maski dotknie środka ekranu
      end: "center center", // Animacja kończy się, gdy dolna część maski dotknie środka ekranu
      scrub: true,         // Płynna animacja w trakcie scrollowania
      markers: markers 
    }
  });

  gsap.from("#"+id+" .right .image", {
    x:  literka_przes, // Przesunięcie o 10% w prawo
    alpha: 0,
    scrollTrigger: {
      trigger: "#"+id,  // Ustawiamy kontener jako punkt wyzwalania
      start: "top center",  // Animacja startuje, gdy górna część maski dotknie środka ekranu
      end: "center center", // Animacja kończy się, gdy dolna część maski dotknie środka ekranu
      scrub: true,         // Płynna animacja w trakcie scrollowania
      markers: markers 
    }
  });








  
});


$(".awx").each(function(){
  var id = $(this).attr('id');


  gsap.from("#"+id+" .left .literka", {
    x:  -literka_przes, // Przesunięcie o 10% w prawo
    alpha: 0,
    scrollTrigger: {
      trigger: "#"+id,  // Ustawiamy kontener jako punkt wyzwalania
      start: "top center",  // Animacja startuje, gdy górna część maski dotknie środka ekranu
      end: "center center", // Animacja kończy się, gdy dolna część maski dotknie środka ekranu
      scrub: true,         // Płynna animacja w trakcie scrollowania
      markers: markers 
    }
  });
  gsap.from("#"+id+" .left .literka_tlo", {
    x:  -literka_tlo_przes, // Przesunięcie o 10% w prawo
    alpha: 0,
    scrollTrigger: {
      trigger: "#"+id,  // Ustawiamy kontener jako punkt wyzwalania
      start: "top center",  // Animacja startuje, gdy górna część maski dotknie środka ekranu
      end: "center center", // Animacja kończy się, gdy dolna część maski dotknie środka ekranu
      scrub: true,        // Płynna animacja w trakcie scrollowania
      markers: markers 
    }
  });

  gsap.from("#"+id+" .left .text", {
    x:  text_przes, // Przesunięcie o 10% w prawo\
    ease: "power2.in",
    alpha: 0,
    duration: 2,
    scrollTrigger: {
      trigger: "#"+id,  // Ustawiamy kontener jako punkt wyzwalania
      start: "top center",  // Animacja startuje, gdy górna część maski dotknie środka ekranu
      end: "center center", // Animacja kończy się, gdy dolna część maski dotknie środka ekranu
      scrub: true,           // Płynna animacja w trakcie scrollowania
      markers: markers 
    }
  });

  gsap.from("#"+id+" .right .literka", {
    x: literka_przes, // Przesunięcie o 10% w prawo
    alpha: 0,
    scrollTrigger: {
      trigger: "#"+id,  // Ustawiamy kontener jako punkt wyzwalania
      start: "top center",  // Animacja startuje, gdy górna część maski dotknie środka ekranu
      end: "center center", // Animacja kończy się, gdy dolna część maski dotknie środka ekranu
      scrub: true,         // Płynna animacja w trakcie scrollowania
      markers: markers 
    }
  });
  gsap.from("#"+id+" .right .literka_tlo", {
    x:  literka_tlo_przes, // Przesunięcie o 10% w prawo
    alpha: 0,
    scrollTrigger: {
      trigger: "#"+id,  // Ustawiamy kontener jako punkt wyzwalania
      start: "top center",  // Animacja startuje, gdy górna część maski dotknie środka ekranu
      end: "center center", // Animacja kończy się, gdy dolna część maski dotknie środka ekranu
      scrub: true,        // Płynna animacja w trakcie scrollowania
      markers: markers 
    }
  });

  gsap.from("#"+id+" .right .text", {
    x:  -text_przes, // Przesunięcie o 10% w prawo\
    alpha: 0,
    ease: "power2.in",
    duration: 2,
    scrollTrigger: {
      trigger: "#"+id,  // Ustawiamy kontener jako punkt wyzwalania
      start: "top center",  // Animacja startuje, gdy górna część maski dotknie środka ekranu
      end: "center center", // Animacja kończy się, gdy dolna część maski dotknie środka ekranu
      scrub: true,           // Płynna animacja w trakcie scrollowania
      markers: markers 
    }
  });

});


var id = $('.solutions').attr('id');
gsap.from("#"+id+" .solutions_text", {
  x:  0.8*windowWidth, // Przesunięcie o 10% w prawo
  alpha: 0,
  scrollTrigger: {
    trigger: "#solutions_text_holder",  // Ustawiamy kontener jako punkt wyzwalania
    start: "top center",  // Animacja startuje, gdy górna część maski dotknie środka ekranu
    end: "bottom center", // Animacja kończy się, gdy dolna część maski dotknie środka ekranu
    scrub: true,         // Płynna animacja w trakcie scrollowania
    markers: markers 
  }
});




const arr = [0.55,1,1.45];
var zakres = windowWidth;
if(zakres > 1440) zakres = 1440;

gsap.utils.toArray(".animation_holder").forEach((holder, i) => {
  gsap.to(holder, {
    y: 0.46*zakres*arr[i], // Naprzemienne przesuwanie w górę i w dół
    ease: "none", // Bez easing'u dla płynności
    scrollTrigger: {
      trigger: '#animations', // Wyzwalacz dla każdej animacji
      start: "top center", // Start, gdy element pojawi się w widoku (u dołu ekranu)
      end: "bottom center", // Koniec, gdy element znika z widoku (u góry ekranu)
      scrub: true, // Płynna synchronizacja z przewijaniem
      markers: false
    }
  });
});

}

gsap.to("#scroll", {
  // scale: 1.2,   // Zwiększamy skalę o 20%
  y: '-20%',
  duration: 0.8,  // Czas trwania animacji
  repeat: -1,   // Powtarzaj w nieskończoność
  yoyo: true,   // Powrót do oryginalnej wielkości po animacji
  ease: "power1.inOut"  // Efekt ease-in-out dla płynniejszej animacji
});




if(is_mobile){

  var maskHeight = $('#maska').height();
  
  ScrollTrigger.create({
    trigger: "#video_mobile", // Element, który chcemy przypiąć
    start: "top top", // Zacznij, gdy element dotknie górnej krawędzi okna
    end: maskHeight, // Koniec efektu po przesunięciu o 100vh
    pin: true, // Przypnij element #video
    pinSpacing: true, // Nie dodawaj dodatkowego miejsca podczas przypinania
    scrub: true // Umożliwia płynne przewijanie
  });
}else{
  ScrollTrigger.create({
    trigger: "#video", // Element, który chcemy przypiąć
    start: "top top", // Zacznij, gdy element dotknie górnej krawędzi okna
    end: "+=100%", // Koniec efektu po przesunięciu o 100vh
    pin: true, // Przypnij element #video
    pinSpacing: true, // Nie dodawaj dodatkowego miejsca podczas przypinania
    scrub: true // Umożliwia płynne przewijanie
  });
}


  // Animacja przesunięcia .mask_text i .mask podczas scrolla
  gsap.to(".mask_text", {
    x: -0.3 * windowWidth, // Przesunięcie o 10% w lewo
    ease: "power2.out",
    scrollTrigger: {
      trigger: "#maska",  // Ustawiamy kontener jako punkt wyzwalania
      start: "+10px top",  // Animacja startuje, gdy górna część maski dotknie środka ekranu
      end: "bottom top", // Animacja kończy się, gdy dolna część maski dotknie środka ekranu
      scrub: true           // Płynna animacja w trakcie scrollowania
    }
  });

  gsap.to(".mask", {
    x: 0.3 * windowWidth, // Przesunięcie o 10% w prawo
    ease: "power2.out",
    scrollTrigger: {
      trigger: "#maska",  // Ustawiamy kontener jako punkt wyzwalania
      start: "top top",  // Animacja startuje, gdy górna część maski dotknie środka ekranu
      end: "bottom top", // Animacja kończy się, gdy dolna część maski dotknie środka ekranu
      scrub: true,           // Płynna animacja w trakcie scrollowania
      markers: markers 
    }
  });



  
});

function cookiesPolicyBar(){
  // Check cookie 


  if ($.cookie('cooki-policy-awx') != "active") {
    $('#cookieAcceptBar').show(); 
  }
  //Assign cookie on click
  $('#cookieAcceptBarConfirm').on('click',function(){
      $.cookie('cooki-policy-awx', 'active', { expires: 1 }); // cookie will expire in one day
      $('#cookieAcceptBar').fadeOut();
  });
}

jQuery(document).ready(function($){
  cookiesPolicyBar();

  $('.openForm').each(function(){
    $(this).click(function(){
      var target = $(this).attr('form_target');
      $(target).toggleClass('active');
    });
  });

   $('#site-navigation li.menu-item a').each(function(){
      $(this).on('click', function(){
        $(this).addClass('active');
        var href = $(this).attr('href');
        var hash = href.split('/').join('');

        scrollTo(hash);

        if(is_mobile === true){
          $('.menu-toggle').removeClass('is-active');
          $('.menu-menu-container').removeClass('is-open');
        
        }

        return false;
      });
   });

   updateContent($('body'));
  //  slickContinuousScroll('#clients_holder');

  $('body').scrollspy({ target: '#primary-menu' });

  $('body').on('activate.bs.scrollspy', function () {
    var href = $('#primary-menu li.menu-item a.active').attr('href');

    if(href){

    var id = href.split('/#').join('');
    updateURL(id);

    }else{
      updateURL('');
    }
  })
});


const updateURL = (id) => {
  if (history.pushState) {
    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}#${id}`;
    history.pushState(null, '', newUrl);
  }
};

// Niestandardowe płynne przewijanie
function slickContinuousScroll(slider) {
  var slider = $(slider);
  var speed = 0.5; // Stała prędkość przesuwania (px/ms)

  // Pobieramy szerokość całego "toru" slajdów
  var sliderWidth = slider[0].scrollWidth;

  // Funkcja do przesuwania
  function move() {
    slider.slick('slickSetOption', 'speed', 0, true); // Ustawienie płynnej animacji
    var scrollLeft = slider.slick('slickGetOption', 'slideWidth');

    slider.animate({ scrollLeft: scrollLeft }, sliderWidth * speed, 'linear', function() {
      // Po zakończeniu przewijania, ustawiamy pozycję z powrotem na początek
      slider.slick('slickGoTo', 0); 
      move(); // Uruchamiamy przewijanie od nowa
    });
  }

  move(); // Uruchamiamy przewijanie
}

 // Wywołujemy funkcję płynnego przewijania

 $(document).ready(function() {
  // Ustawienie początkowych kierunków dla obu sliderów
  let direction1 = 1; // 1 - w prawo, -1 - w lewo
  let direction2 = -1; // 1 - w prawo, -1 - w lewo

  // Inicjalizacja slidera #projects_holder1
  const $slider1 = $('#projects_holder1').slick({
      infinite: true,
      speed: 800,
      variableWidth: true,
      slidesToShow: 8,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<div class="prevArrow"></div>',
      nextArrow: '<div class="nextArrow"></div>',
      pauseOnHover:true,
  });

  // Inicjalizacja slidera #projects_holder2
  const $slider2 = $('#projects_holder2').slick({
      infinite: true,
      variableWidth: true,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<div class="prevArrow"></div>',
      nextArrow: '<div class="nextArrow"></div>',
      pauseOnHover:true,
  });

  function slideSlider1() {
    if (direction1 === 1) {
        $slider1.slick('slickNext');
    } else {
        $slider1.slick('slickPrev');
    }
  }
  function slideSlider2() {
    if (direction2 === 1) {
        $slider2.slick('slickNext');
    } else {
        $slider2.slick('slickPrev');
    }
}

// Zdarzenie po każdej zmianie slajdu dla slidera #projects_holder1
$slider1.on('afterChange', function(event, slick, currentSlide) {
    if (currentSlide === slick.slideCount - 1 && direction1 === 1) {
        direction1 = -1; // Zmień kierunek na lewo dla slidera #projects_holder1
    } else if (currentSlide === 0 && direction1 === -1) {
        direction1 = 1; // Zmień kierunek na prawo dla slidera #projects_holder1
    }
});

// Zdarzenie po każdej zmianie slajdu dla slidera #projects_holder2
$slider2.on('afterChange', function(event, slick, currentSlide) {
    if (currentSlide === slick.slideCount - 1 && direction2 === 1) {
        direction2 = -1; // Zmień kierunek na lewo dla slidera #projects_holder2
    } else if (currentSlide === 0 && direction2 === -1) {
        direction2 = 1; // Zmień kierunek na prawo dla slidera #projects_holder2
    }
});

// Przykładowy interwał przesuwania slajdów co 2 sekundy
let slideInterval1 = setInterval(slideSlider1, 2000);
let slideInterval2 = setInterval(slideSlider2, 2000);

// Zatrzymywanie animacji tylko dla slidera nad którym znajduje się kursor
$slider1.on('mouseenter', function() {
    clearInterval(slideInterval1); // Zatrzymaj automatyczną animację
    
    $slider1.slick('slickPause');
    $slider1.slick('slickSetOption', 'speed', 400, false);
}).on('mouseleave', function() {
    $slider1.slick('slickSetOption', 'speed', 800, false);
    slideInterval1 = setInterval(slideSlider1, 2000); // Wznów automatyczną animację
});

$slider2.on('mouseenter', function() {
    clearInterval(slideInterval2); // Zatrzymaj automatyczną animację
    $slider2.slick('slickPause');
    $slider2.slick('slickSetOption', 'speed', 400, false);
}).on('mouseleave', function() {
    $slider2.slick('slickSetOption', 'speed', 800, false);
    slideInterval2 = setInterval(slideSlider2, 2000); // Wznów automatyczną animację
});



});

function updateContent(parent){
  $(parent).find('.slickSlider').each(function(){
    var ID = $(this).attr('id');
    var resp = $(this).attr('slick_per_page').split('_');
    var showDots = $(this).attr('slick_show_dots') && $(this).attr('slick_show_dots')=='1' ? true : false;
    var hideArrows = $(this).attr('slick_hide_arrows') && $(this).attr('slick_hide_arrows')=='1' ? false : true;
    var varWidth = $(this).attr('variable_width') && $(this).attr('variable_width')=='1' ? true : false;
    var center_mode = $(this).attr('center_mode') && $(this).attr('center_mode')=='0' ? false : true;
    var infinite = $(this).attr('infinite') && $(this).attr('infinite')=='0' ? false : true;
    var speed = $(this).attr('speed') ? $(this).attr('speed') : 5000;
    var fade = $(this).attr('fade') && $(this).attr('fade')=='1' ? true : false;

    

    var resp_1 = circumference(resp[0] ? resp[0] : 4);
    var resp_2 = circumference(resp[1] ? resp[1] : 3);
    var resp_3 = circumference(resp[2] ? resp[2] : 1);
    var resp_4 = circumference(resp[3] ? resp[3] : 1);



    var customArrows = $(this).attr('navigation') ? true : false;
    var prevArr = customArrows ? $('#'+$(this).attr('navigation')+' .slick-prev') : '<button class="slick-prev slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true" style="">Previous</button>';
    var nextArr = customArrows ? $('#'+$(this).attr('navigation')+' .slick-next') : '<button class="slick-next slick-arrow slick-disabled" aria-label="Next" type="button" style="" aria-disabled="true">Next</button>';

    $('#'+ID).slick({
      dots: showDots,
      arrows: hideArrows,
      infinite: infinite,
      speed: 1500,
      fade: false,
      autoplay: true,
      autoplaySpeed: 1000,
      
      variableWidth: varWidth,
      centerMode: false, 
      cssEase: 'linear',
      slidesToShow: resp_1,
      slidesToScroll: resp_1,
      swipeToSlide: true,
      prevArrow: prevArr,
      nextArrow: nextArr,
      pauseOnHover:true,

      responsive: [
        {
          breakpoint: 1200,
          settings: {
            dots: showDots,
            slidesToShow: resp_2,
            slidesToScroll: resp_2,
            infinite: infinite,
            variableWidth: true
          }
        },
        {
          breakpoint: 920,
          settings: {
            slidesToShow: resp_3,
            slidesToScroll: resp_3,
            variableWidth: true
          }
        },
        {
          breakpoint: 650,
          settings: {
            speed: 1000,
            slidesToShow: resp_4,
            slidesToScroll: resp_4,
            centerMode: false, 
            variableWidth: false
          }
        }

      ]
    }); 
  
  $('#'+ID).on('afterChange', slickInit);
  $('#'+ID).trigger('afterChange');

  $('#'+ ID).find('.slider-menu li').each(function(){
      $(this).on('click', function(){
        
          $('#'+ ID).slick('slickGoTo', $(this).attr('slider-index'));
          return false;
      });
  });
  
});
}



function circumference(r) {
  if (Number.isNaN(Number.parseFloat(r))) {
    return 0;
  }
  return parseFloat(r) ;
}

function slickInit(slick, currentTarget){
  var moveDots = $(slick.target).hasClass('moveDots') ? true : false;
  if(moveDots){
    var moveDotsTo = $($(slick.target).attr('move-dots-to'));
    var moveDotsFrom = $($(slick.target).find('.slick-dots'));
    moveDotsFrom.addClass('slick-dots-outside');
    moveDotsTo.append(moveDotsFrom);
  }

}